var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnerOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6830_82016)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6830_82016)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_6830_82016)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9153 8.47778C24.333 8.47778 28.7836 16.9552 28.7836 16.9552C28.7836 16.9552 24.333 25.4326 16.9153 25.4326C9.49752 25.4326 5.04688 16.9552 5.04688 16.9552C5.04688 16.9552 9.49752 8.47778 16.9153 8.47778ZM9.24977 13.8062C8.32943 14.7675 7.50439 15.8225 6.78708 16.9552H6.78559C7.50292 18.0879 8.32796 19.1429 9.24828 20.1042C10.2233 21.2288 11.4025 22.1423 12.7182 22.7922C14.0339 23.4421 15.4602 23.8156 16.9153 23.8913C18.369 23.8144 19.7938 23.4404 21.1082 22.7905C22.4225 22.1407 23.6006 21.2278 24.5748 20.1042C25.3733 19.2696 26.1005 18.3645 26.7482 17.3991C26.8639 17.2373 26.9588 17.0894 27.0449 16.9553L27.0449 16.9552C26.3276 15.8225 25.5026 14.7675 24.5822 13.8062C23.6072 12.6816 22.428 11.7681 21.1123 11.1182C19.7966 10.4683 18.3703 10.0948 16.9153 10.0191C15.4604 10.0945 14.0342 10.4679 12.7187 11.1178C11.4032 11.7677 10.2243 12.6814 9.24977 13.8062ZM14.8961 13.9345C15.4936 13.5353 16.196 13.3222 16.9146 13.3222C17.8782 13.3222 18.8023 13.7049 19.4836 14.3863C20.165 15.0677 20.5478 15.9918 20.5478 16.9553C20.5478 17.6739 20.3347 18.3764 19.9355 18.9738C19.5362 19.5713 18.9688 20.037 18.3049 20.312C17.6411 20.587 16.9105 20.6589 16.2058 20.5187C15.501 20.3785 14.8536 20.0325 14.3455 19.5244C13.8374 19.0163 13.4914 18.3689 13.3512 17.6641C13.211 16.9594 13.283 16.2289 13.558 15.565C13.8329 14.9011 14.2986 14.3337 14.8961 13.9345ZM12.6853 14.1295C12.1264 14.9659 11.8281 15.9493 11.8281 16.9553C11.8281 18.3044 12.364 19.5981 13.3179 20.552C14.2718 21.5059 15.5656 22.0418 16.9146 22.0418C17.9206 22.0418 18.904 21.7435 19.7405 21.1846C20.5769 20.6257 21.2289 19.8313 21.6138 18.9018C21.9988 17.9724 22.0996 16.9497 21.9033 15.963C21.707 14.9764 21.2226 14.07 20.5112 13.3587C19.7999 12.6473 18.8936 12.1629 17.9069 11.9666C16.9202 11.7704 15.8975 11.8711 14.9681 12.2561C14.0386 12.6411 13.2443 13.293 12.6853 14.1295Z",
    fill: "#6621F1"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6830_82016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.992188 0.955078)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6830_82016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.992188 0.955078)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_6830_82016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.992188 0.955078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerOverview);
export default __webpack_public_path__ + "static/media/partner-overview.b78246692dc1c55b2b12e0579a3b1ea3.svg";
export { ForwardRef as ReactComponent };